<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center" style="gap: 10px">
            <label class="label-input mb-0">Card Title</label>
            <input type="checkbox" v-model="fields.cardTitle.show" />
          </div>
          <div class="group-item" v-if="fields.cardTitle.show">
            <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Comparison Block Colors</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.wrapContent.bgContent"
                  default-color="#1c150c"
                  label="Content Background"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.wrapContent.colorText"
                  default-color="#ffffff"
                  label="Content Text Color"
                  hide-details
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <div class="mb-4">
              <label class="label-input">Left Card (Media & Benefits)</label>
              <div class="group-item">
                <div class="mb-3">
                  <v-select
                    label="Left Card Display Order"
                    :items="[
                      { text: 'Left', value: 1 },
                      { text: 'Right', value: 2 },
                    ]"
                    :value="fields.leftCard.order"
                    @change="handleChangeOrder"
                    hide-details
                  />
                </div>
                <!-- <v-text-field
                  v-model.number="fields.leftCard.order"
                  type="number"
                  label="Display Order (1 or 2)"
                  class="mb-3"
                  hide-details
                /> -->
                <v-checkbox v-model="fields.leftCard.useVideo" label="Use Video (Uncheck for Image)" hide-details />

                <div v-if="fields.leftCard.useVideo" class="mt-2 mb-3">
                  <v-text-field v-model="fields.leftCard.videoSrc" label="Video URL" hide-details />
                </div>
                <div v-else class="mt-2 mb-3">
                  <label class="mb-2 d-block">Left Card Image</label>
                  <UploadImage
                    @callback="handleUploadLeftCardImage"
                    :image="{ imageSrc: fields.leftCard.imageSrc }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveLeftCardImage"
                  />
                  <v-text-field v-model="fields.leftCard.imageAlt" label="Image Alt" class="mt-2" hide-details />
                </div>

                <div class="mt-4">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <label class="font-weight-medium">Benefits List (Max 3) </label>
                    <v-btn
                      :disabled="fields.leftCard.benefits.length >= 3"
                      small
                      text
                      color="primary"
                      @click="handleAddLeftBenefit"
                    >
                      <v-icon size="16">mdi-plus</v-icon>
                      <span>Add</span>
                    </v-btn>
                  </div>
                  <v-expansion-panels accordion v-if="fields.leftCard.benefits && fields.leftCard.benefits.length">
                    <v-expansion-panel
                      v-for="(benefit, index) in fields.leftCard.benefits"
                      :key="`left-benefit-${index}`"
                    >
                      <v-expansion-panel-header>
                        <div class="d-flex justify-space-between align-center">
                          <span>Benefit {{ index + 1 }}</span>
                          <v-btn icon @click.stop="handleRemoveLeftBenefit(index)">
                            <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <ckeditor :editor="editor" v-model="benefit.content" :config="editorConfig" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="mb-4">
              <label class="label-input">Right Card (Comparison)</label>
              <div class="group-item">
                <!-- <v-text-field
                  v-model.number="fields.rightCard.order"
                  type="number"
                  label="Display Order (1 or 2)"
                  class="mb-4"
                  hide-details
                /> -->

                <div class="mb-4">
                  <label class="font-weight-medium d-block mb-2">Left Compare Image (e.g. Standard)</label>
                  <UploadImage
                    @callback="handleUploadLeftCompareImage"
                    :image="{ imageSrc: fields.rightCard.leftCompare.image }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveLeftCompareImage"
                  />
                  <v-row class="mt-2">
                    <v-col cols="12" md="6">
                      <v-text-field v-model="fields.rightCard.leftCompare.title" label="Label Text" hide-details />
                    </v-col>
                    <v-col cols="12" md="6">
                      <ColorPicker
                        v-model="fields.rightCard.leftCompare.color"
                        default-color="#ffffff"
                        label="Text Color"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12">
                      <ColorPicker
                        v-model="fields.rightCard.leftCompare.bg"
                        default-color="#535353"
                        label="Background Color"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </div>

                <div class="mb-4">
                  <label class="font-weight-medium d-block mb-2">Right Compare Image (e.g. Our Magnifier)</label>
                  <UploadImage
                    @callback="handleUploadRightCompareImage"
                    :image="{ imageSrc: fields.rightCard.rightCompare.image }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveRightCompareImage"
                  />
                  <v-row class="mt-2">
                    <v-col cols="12" md="6">
                      <v-text-field v-model="fields.rightCard.rightCompare.title" label="Label Text" hide-details />
                    </v-col>
                    <v-col cols="12" md="6">
                      <ColorPicker
                        v-model="fields.rightCard.rightCompare.color"
                        default-color="#ffffff"
                        label="Text Color"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12">
                      <ColorPicker
                        v-model="fields.rightCard.rightCompare.bg"
                        default-color="#c75023"
                        label="Background Color"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </div>

                <div>
                  <div class="d-flex justify-space-between align-center mb-2">
                    <label class="font-weight-medium">Compare By Text rows</label>
                    <v-btn small text color="primary" @click="handleAddTextCompareRow">
                      <v-icon size="16">mdi-plus</v-icon>
                      <span>Add</span>
                    </v-btn>
                  </div>
                  <v-expansion-panels
                    accordion
                    v-if="fields.rightCard.textCompareList && fields.rightCard.textCompareList.length"
                  >
                    <v-expansion-panel
                      v-for="(row, index) in fields.rightCard.textCompareList"
                      :key="`text-row-${index}`"
                    >
                      <v-expansion-panel-header>
                        <div class="d-flex justify-space-between align-center">
                          <span>Row {{ index + 1 }}: {{ row.text }}</span>
                          <v-btn icon @click.stop="handleRemoveTextCompareRow(index)">
                            <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="mb-2">
                          <label class="mb-1 d-block">Prefix Icon</label>
                          <UploadImage
                            @callback="obj => handleUploadPrefixIcon(obj, index)"
                            :image="{ imageSrc: row.iconPrefix || '' }"
                            :height="`80`"
                            :typeUpload="'image'"
                            @callbackDelete="() => handleRemovePrefixIcon(index)"
                          />
                        </div>
                        <v-text-field v-model="row.text" label="Comparison Text" class="mb-2" hide-details />
                        <div>
                          <label class="mb-1 d-block">Suffix Icon</label>
                          <UploadImage
                            @callback="obj => handleUploadSuffixIcon(obj, index)"
                            :image="{ imageSrc: row.iconSuffix || '' }"
                            :height="`80`"
                            :typeUpload="'image'"
                            @callbackDelete="() => handleRemoveSuffixIcon(index)"
                          />
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <div class="mb-4">
          <div class="d-flex align-center" style="gap: 10px">
            <label class="label-input mb-0">Call To Action Button</label>
            <input type="checkbox" v-model="fields.button.show" />
          </div>
          <div class="group-item" v-if="fields.button.show">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.text" label="Button Text" hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.href" label="Button Link" hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.button.bgButton"
                  default-color="#c75023"
                  label="Button Background Color"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.button.colorButton"
                  default-color="#ffffff"
                  label="Button Text Color"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="12">
                <div>
                  <v-checkbox v-model="fields.button.showDiscount" label="Show Discount" hide-details />
                </div>
                <div v-if="fields.button.showDiscount">
                  <v-text-field v-model="fields.button.valueDiscount" suffix="%" hide-details />
                </div>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="fields.button.showIcon" label="Button Icon" hide-details />
                <div v-if="fields.button.showIcon">
                  <UploadImage
                    @callback="handleUploadButtonIcon"
                    :image="{ imageSrc: fields.button.icon }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveButtonIcon"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import ColorPicker from './common/color-picker.vue';

export default {
  name: 'card-compare-sowhatbuy-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Card Compare Sowhatbuy Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardTitle: {
          show: true,
          content: '',
        },
        wrapContent: {
          bgContent: '#1c150c',
          colorText: '#ffffff',
        },
        leftCard: {
          useVideo: true,
          order: 1,
          videoSrc: '',
          imageSrc: '',
          imageAlt: '',
          benefits: [],
        },
        rightCard: {
          order: 2,
          leftCompare: {
            image: '',
            alt: '',
            title: '',
            color: '#ffffff',
            bg: '#535353',
          },
          rightCompare: {
            image: '',
            alt: '',
            title: '',
            color: '#ffffff',
            bg: '#c75023',
          },
          textCompareList: [],
        },
        button: {
          show: true,
          href: '',
          showDiscount: true,
          valueDiscount: '50',
          text: 'Buy Now',
          showIcon: true,
          icon: '',
          bgButton: '#c75023',
          colorButton: '#ffffff',
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardTitle: { ...this.fields.cardTitle, ...(extract.cardTitle || {}) },
        wrapContent: { ...this.fields.wrapContent, ...(extract.wrapContent || {}) },
        leftCard: {
          ...this.fields.leftCard,
          ...(extract.leftCard || {}),
          benefits: Array.isArray(extract.leftCard?.benefits) ? extract.leftCard.benefits.map(b => ({ ...b })) : [],
        },
        rightCard: {
          ...this.fields.rightCard,
          ...(extract.rightCard || {}),
          leftCompare: { ...this.fields.rightCard.leftCompare, ...(extract.rightCard?.leftCompare || {}) },
          rightCompare: { ...this.fields.rightCard.rightCompare, ...(extract.rightCard?.rightCompare || {}) },
          textCompareList: Array.isArray(extract.rightCard?.textCompareList)
            ? extract.rightCard.textCompareList.map(t => ({ ...t }))
            : [],
        },
        button: { ...this.fields.button, ...(extract.button || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardCompareSowhatbuy(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadLeftCardImage(obj) {
      this.$set(this.fields.leftCard, 'imageSrc', obj.imageSrc || '');
    },
    handleRemoveLeftCardImage() {
      this.$set(this.fields.leftCard, 'imageSrc', '');
    },
    handleUploadLeftCompareImage(obj) {
      this.$set(this.fields.rightCard.leftCompare, 'image', obj.imageSrc || '');
    },
    handleRemoveLeftCompareImage() {
      this.$set(this.fields.rightCard.leftCompare, 'image', '');
    },
    handleUploadRightCompareImage(obj) {
      this.$set(this.fields.rightCard.rightCompare, 'image', obj.imageSrc || '');
    },
    handleRemoveRightCompareImage() {
      this.$set(this.fields.rightCard.rightCompare, 'image', '');
    },
    handleUploadButtonIcon(obj) {
      this.$set(this.fields.button, 'icon', obj.imageSrc || '');
    },
    handleRemoveButtonIcon() {
      this.$set(this.fields.button, 'icon', '');
    },
    handleAddLeftBenefit() {
      if (!this.fields.leftCard.benefits) {
        this.$set(this.fields.leftCard, 'benefits', []);
      }
      this.fields.leftCard.benefits.push({ content: '<p>Value</p><p>Label</p>' });
    },
    handleRemoveLeftBenefit(index) {
      this.fields.leftCard.benefits.splice(index, 1);
    },
    handleAddTextCompareRow() {
      if (!this.fields.rightCard.textCompareList) {
        this.$set(this.fields.rightCard, 'textCompareList', []);
      }
      this.fields.rightCard.textCompareList.push({ iconPrefix: '', text: 'Point details', iconSuffix: '' });
    },
    handleRemoveTextCompareRow(index) {
      this.fields.rightCard.textCompareList.splice(index, 1);
    },
    handleUploadPrefixIcon(obj, index) {
      if (!this.fields.rightCard.textCompareList[index]) return;
      this.$set(this.fields.rightCard.textCompareList[index], 'iconPrefix', obj.imageSrc || '');
    },
    handleRemovePrefixIcon(index) {
      if (!this.fields.rightCard.textCompareList[index]) return;
      this.$set(this.fields.rightCard.textCompareList[index], 'iconPrefix', '');
    },
    handleUploadSuffixIcon(obj, index) {
      if (!this.fields.rightCard.textCompareList[index]) return;
      this.$set(this.fields.rightCard.textCompareList[index], 'iconSuffix', obj.imageSrc || '');
    },
    handleRemoveSuffixIcon(index) {
      if (!this.fields.rightCard.textCompareList[index]) return;
      this.$set(this.fields.rightCard.textCompareList[index], 'iconSuffix', '');
    },
    handleChangeOrder(order) {
      if (order === 1) {
        this.fields.leftCard.order = order;
        this.fields.rightCard.order = 2;
      } else {
        this.fields.leftCard.order = order;
        this.fields.rightCard.order = 1;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
